import { Key, TreeNode } from './type';
/*
export const traverseTreeData = ({
  treeData = [],
  callback = () => {
    return null;
  },
  parentId = null,
  replaceName = 'children',
}: any) => {
  // 遍历树形数据
  treeData.forEach((item: any, index: any) => {
    callback(item, index, parentId);
    if (item[replaceName] && item[replaceName].length > 0) {
      traverseTreeData({
        treeData: item[replaceName],
        callback,
        parentId: item.key,
        replaceName,
      });
    }
  });
};
*/

export const isChecked = (
  key: Key,
  children: TreeNode[] | undefined,
  checkedKeys: Key[]
): boolean => {
  if (checkedKeys.includes(key)) {
    return true;
  } else if (!children || children.length === 0) {
    return false;
  } else {
    return children.every((child) =>
      isChecked(child.key, child.children, checkedKeys)
    );
  }
  // if (checkedKeys.includes(key)) {
  //   return true;
  // } else {
  //   return false;
  // }
};

export const isIndeterminate = (
  key: Key,
  children: TreeNode[] | undefined,
  checkedKeys: Key[]
): boolean => {
  if (!children) {
    return false;
  }
  const allChildrenKeys = getAllKeys(key, children);
  const uncheckableKeys = getUncheckableKeys(key, children);
  const allCheckableKeys = allChildrenKeys.filter(
    (childKey) => !uncheckableKeys.includes(childKey)
  );
  const checkedCount = allCheckableKeys.filter((childKey) =>
    checkedKeys.includes(childKey)
  ).length;
  return checkedCount > 0 && checkedCount < allCheckableKeys.length;

  // const checkedArray = children.map((child) => {
  //   if (child.children) {
  //     return isIndeterminate(child.key, child.children, checkedKeys);
  //   } else {
  //     return checkedKeys.includes(child.key);
  //   }
  // });
  // return checkedArray.some((item) => item === true);

  // const checkedCount = children.filter((child) =>
  //   checkedKeys.includes(child.key)
  // ).length;
  // return checkedCount > 0 && checkedCount < children.length;
};

export const getCheckedKeys = (
  key: Key,
  children: TreeNode[] | undefined,
  checked: boolean,
  checkedKeys: Key[]
  // childCheckedKeys: Key[] = []
): Key[] => {
  // if (children) {
  //   children.forEach((child) => {
  //     const childChecked = checked || childCheckedKeys.includes(child.key);
  //     const newChildCheckedKeys = getCheckedKeys(
  //       child.key,
  //       child.children,
  //       childChecked,
  //       checkedKeys,
  //       childCheckedKeys
  //     );
  //     newCheckedKeys.push(...newChildCheckedKeys);
  //   });
  // }
  const allKeys = getAllKeys(key, children);
  let newCheckedKeys = checked
    ? Array.from(new Set([...checkedKeys, ...allKeys]))
    : checkedKeys.filter((key) => !allKeys.includes(key));
  // filter out the keys of disableCheckbox node
  const uncheckableKeys = getUncheckableKeys(key, children);
  newCheckedKeys = newCheckedKeys.filter(
    (checkedKey) => !uncheckableKeys.includes(checkedKey)
  );
  return newCheckedKeys;
};

export const getAllKeys = (key: Key, children: TreeNode[] | undefined) => {
  const keys = [key];
  if (children) {
    children.forEach((child) => {
      keys.push(...getAllKeys(child.key, child.children));
    });
  }
  return keys;
};
// get all the uncheckable keys of its children
export const getUncheckableKeys = (
  key: Key,
  children: TreeNode[] | undefined
) => {
  const keys: Key[] = [];
  if (children) {
    children.forEach((child) => {
      if (!child.disableCheckbox) {
        keys.push(...getUncheckableKeys(child.key, child.children));
      } else {
        keys.push(...getAllKeys(child.key, child.children));
      }
    });
  }
  return keys;
};
